import { CustomMaterialModule } from '../../core/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared-module/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MomentModule } from 'ngx-moment';
import { MatSelectModule } from '@angular/material';
import { NgxUploaderModule } from 'ngx-uploader';
import { ImageCropperModule } from 'ngx-image-cropper';
import { CheckoutFormComponent } from './checkout-form/checkout-form.component';
import { FinnFormComponent } from './finn-form/finn-form.component';
import { JobBoardsComponent } from './job-boards/job-boards.component';
import { JobSocialMediaPreviewComponent } from './job-social-media-preview/job-social-media-preview.component';

export const COMPONENTS = [
  CheckoutFormComponent,
  FinnFormComponent,
  JobBoardsComponent,
  JobSocialMediaPreviewComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FlexLayoutModule,
    SharedModule,
    TranslateModule,
    MatSelectModule,
    CustomMaterialModule,
    NgxUploaderModule,
    ImageCropperModule,
    MomentModule,
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
  providers: [],
  entryComponents: [FinnFormComponent, CheckoutFormComponent],
})
export class ComponentsModule {}
